export default __webpack_public_path__ + "static/media/insta-4.2445936a.jpg";